import { ref } from 'vue'

const isInstagramLoaded = ref(false)

export function useSocialScripts() {
  const loadInstagramScript = () => {
    return new Promise((resolve) => {
      // If already loaded
      if (isInstagramLoaded.value) {
        resolve(true)
        return
      }

      // If window.instgrm already exists
      if (window.instgrm) {
        isInstagramLoaded.value = true
        resolve(true)
        return
      }

      // If script tag exists but not initialized
      const existingScript = document.querySelector('script[src*="instagram.com/embed.js"]')
      if (existingScript) {
        const checkInstagram = () => {
          if (window.instgrm) {
            isInstagramLoaded.value = true
            resolve(true)
          } else {
            setTimeout(checkInstagram, 100)
          }
        }
        checkInstagram()
        return
      }

      // Create and load script
      const script = document.createElement('script')
      script.src = 'https://www.instagram.com/embed.js'
      script.async = true
      script.defer = true

      script.onload = () => {
        const checkInstagram = () => {
          if (window.instgrm) {
            isInstagramLoaded.value = true
            resolve(true)
          } else {
            setTimeout(checkInstagram, 100)
          }
        }
        checkInstagram()
      }

      document.body.appendChild(script)
    })
  }

  const processInstagramEmbeds = () => {
    if (window.instgrm?.Embeds?.process) {
      window.instgrm.Embeds.process()
    }
  }

  return {
    isInstagramLoaded,
    loadInstagramScript,
    processInstagramEmbeds
  }
} 